module.exports = __webpack_public_path__ + "static/fonts/Lato-Bold.44dfe8cc.ttf";